'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Thumb = require('components/Thumb/Thumb');

var _Thumb2 = _interopRequireDefault(_Thumb);

var _MyPlaylistItemPopover = require('./MyPlaylistItemPopover');

var _MyPlaylistItemPopover2 = _interopRequireDefault(_MyPlaylistItemPopover);

var _reactRouterRedux = require('react-router-redux');

var _audioplayer = require('redux/modules/audioplayer');

var audioplayerActions = _interopRequireWildcard(_audioplayer);

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _MyPlaylistDescription = require('./MyPlaylistDescription');

var _MyPlaylistDescription2 = _interopRequireDefault(_MyPlaylistDescription);

var _MoreButton = require('components/MoreButton/MoreButton');

var _MoreButton2 = _interopRequireDefault(_MoreButton);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _reactI18next = require('react-i18next');

var _myPlaylists2 = require('selectors/my-playlists');

var _Checkbox = require('components/Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _utils = require('helpers/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistItem.scss');

var MyPlaylistItem = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    deletePlaylistActionData: state.myPlaylists.deleteMyPlaylistActionData,
    deletePlaylistLoading: state.myPlaylists.deleteMyPlaylistLoading,
    playlistTracks: (0, _myPlaylists2.getMyPlaylisTracks)(state, ownProps.playlist.guid)
  };
}, (0, _extends3.default)({}, myPlaylistsActions, audioplayerActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MyPlaylistItem, _Component);

  function MyPlaylistItem() {
    (0, _classCallCheck3.default)(this, MyPlaylistItem);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistItem.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistItem, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          onClick = _props.onClick,
          playlist = _props.playlist;

      if (this.props.clickable) {
        this.edit();
      }
      onClick(playlist);
    }
  }, {
    key: 'deletePlaylist',
    value: function deletePlaylist() {
      var _props2 = this.props,
          guid = _props2.playlist.guid,
          deleteMyPlaylist = _props2.deleteMyPlaylist,
          t = _props2.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteMyPlaylist({ guid: guid });
        }
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this playlist?'), toastrConfirmOptions);
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      this.popover.toggle(e);
    }
  }, {
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.popover = el;
    }
  }, {
    key: 'playAll',
    value: function playAll() {
      var _props3 = this.props,
          playAlbum = _props3.playAlbum,
          album = _props3.playlist,
          tracks = _props3.playlistTracks;

      playAlbum({ album: album, tracks: tracks });
    }
  }, {
    key: 'edit',
    value: function edit() {
      var _props4 = this.props,
          pushState = _props4.pushState,
          playlist = _props4.playlist;

      pushState('/my-playlists/' + playlist.guid);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          playlist = _props5.playlist,
          deletePlaylistActionData = _props5.deletePlaylistActionData,
          deletePlaylistLoading = _props5.deletePlaylistLoading,
          playlistTracks = _props5.playlistTracks,
          checked = _props5.checked,
          withOptions = _props5.withOptions,
          withIndex = _props5.withIndex,
          index = _props5.index,
          selectable = _props5.selectable;

      var isDeleting = deletePlaylistLoading && deletePlaylistActionData.guid === playlist.guid;

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.listItem), onClick: this.onClick },
        withIndex && _react2.default.createElement(
          'div',
          { className: styles.index },
          index
        ),
        _react2.default.createElement(_Thumb2.default, {
          fileName: playlist.thumb,
          defaultImageName: 'default-logo',
          asBackground: true,
          className: styles.thumb
        }),
        _react2.default.createElement(_MyPlaylistDescription2.default, {
          tracksCount: playlistTracks.length,
          name: playlist.name
        }),
        withOptions && _react2.default.createElement(_MoreButton2.default, { loading: isDeleting, onClick: this.togglePopover }),
        selectable && _react2.default.createElement(_Checkbox2.default, {
          className: styles.checkbox,
          checked: checked,
          onClick: _utils.stopEvent,
          small: true
        }),
        withOptions && _react2.default.createElement(_MyPlaylistItemPopover2.default, {
          id: 'myPlaylistItemPopover_' + playlist.guid,
          onInit: this.bindPopover,
          onPlayAll: this.playAll,
          onDelete: this.deletePlaylist,
          hidePlayAll: !playlistTracks.length
        })
      );
    }
  }]);
  return MyPlaylistItem;
}(_react.Component), _class3.propTypes = {
  checked: _propTypes2.default.bool,
  clickable: _propTypes2.default.bool,
  deleteMyPlaylist: _propTypes2.default.func,
  deletePlaylistActionData: _propTypes2.default.object,
  deletePlaylistLoading: _propTypes2.default.bool,
  index: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  playAlbum: _propTypes2.default.func,
  playlist: _propTypes2.default.object,
  playlistTracks: _propTypes2.default.array,
  pushState: _propTypes2.default.func,
  selectable: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  withIndex: _propTypes2.default.bool,
  withOptions: _propTypes2.default.bool
}, _class3.defaultProps = {
  clickable: true,
  onClick: _noop3.default,
  playlist: {},
  playlistTracks: [],
  selectable: false,
  withOptions: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deletePlaylist', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deletePlaylist'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'togglePopover'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindPopover'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playAll'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'edit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'edit'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MyPlaylistItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/components/MyPlaylistItem.js
// module id = 2174
// module chunks = 1